export const itemWiseReportSubMenu = [{
  path: '/report/itemWiseReport/list',
  component: () => import('@/views/report/item-wise-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.itemWiseReport.title',
    roles: ['Super Admin', 'Read Only', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'building'
  }
}];